export default theme => ({
  iconButton: {
    padding: 9,
  },
});
